import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/core/services/auth/auth.service';
import { BaseModalService } from 'src/utils/base-modal.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const baseModalService = inject(BaseModalService)

  if (authService.isLoggedIn()) {
    return true;
  } else {
    router.navigate(['/auth/login'], { queryParams: { unauthorized: 'true', returnUrl: state.url } });
    baseModalService.forceClose();
    return false;
  }
};